module.exports = __webpack_public_path__ + "img/add.071058f5.png";